export default __webpack_public_path__ + "static/media/FC_1.49e5a993.png";